<template>
  <div class="col-lg-3 col-md-6 col-12 folovid__col mb-3">
    <div class="folovid__col-contenido pt-3 pb-2 mx-auto px-3 text-center">
      <p class="folovid__texto mb-0">Estado inmunización Compañía</p>
      <div class="row folovid__row justify-content-center" v-if="estadisticas">
        <div class="col-lg-9 col-sm-6 col-5 folovid__col mt-3">
          <img
            src="@/assets/img/intranet/folovid/icono-vacuna-circular.png"
            class="folovid__icono-vacuna img-fluid"
            alt="Ícono de vacunación"
          />
        </div>
        <div class="col-lg-11 col-md-11 col-11">
          <span class="folovid__numero-inmunizados" :style="{ color: colorPrimario }">{{ estadisticas.total_vacunados }}</span>
        </div>
        <div class="col-lg-11 col-md-11 col-11">
          <p class="folovid__texto folovid__texto--normal mb-0">
            Personas en <span>{{ estadisticas.total_usuarios }}</span> <br> que están inmunizadas
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EstadoInmunizacion",
  props: {
    estadisticas: Object
  },
};
</script>